import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center justify-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary/90 text-primary-foreground shadow-sm hover:bg-primary",
        secondary: "border-transparent bg-muted text-muted-foreground shadow-sm hover:bg-muted/80",
        destructive: "border-transparent bg-destructive/90 text-destructive-foreground shadow-sm hover:bg-destructive",
        warning: "border-transparent bg-warning/90 text-warning-foreground shadow-sm hover:bg-warning",
        success: "border-transparent bg-success/90 text-success-foreground shadow-sm hover:bg-success",
        outline: "text-foreground border-border bg-background/50 backdrop-blur-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
